/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var UIUtil = require('psa-core/util/ui');
var GridView = require('psa-marionette/views/GridView');

var ConfirmationModalView = require('common/views/ConfirmationModalView');
var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var MomentCell = require('common/backgrid/MomentCell');

var SubmitAffiliate = require('../services/SubmitAffiliate');

module.exports = GridView.extend({
  className: 'corp-fin-affiliates-section-view',

  onBeforeRender: function() {
    if (GridView.prototype.onBeforeRender) {
      GridView.prototype.onBeforeRender.apply(this.arguments);
    }

    var isReadOnly = this.options.isReadOnly;

    var self = this;
    this.options.columns = [
      {
        name: 'displayName',
        label: 'Affiliate Name',
        cell: 'string',
        headerCell: 'custom',
        width: 25,
        editable: false
      },
      {
        name: 'titleDisplay',
        label: 'Title',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'terminationDate',
        label: 'Termination Date',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 25,
        editable: false
      },
      {
        name: 'typeDisplay',
        label: 'Corporation/Individual',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'editDeleteMultiButtonCell',
        label: '',
        width: 10,
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: '',
              labelClass: 'fa fa-edit',
              buttonClass: 'btn-primary btn-sm edit-affiliate',
              href: function(model) {
                var isRegistration = self.options.recordCategoryId === '1';
                var isExemption = self.options.recordCategoryId === '2';

                if (isRegistration) {
                  return '#corpfin/registration/' + model.get('recordId') + '/affiliate/' + model.get('id') + '/edit';
                } else if (isExemption) {
                  return '#corpfin/exemption/' + model.get('recordId') + '/affiliate/' + model.get('id') + '/edit';
                }
              },
              renderable: function() {
                return !isReadOnly;
              }
            },
            {
              name: '',
              labelClass: 'fa fa-trash',
              buttonClass: 'btn-danger btn-sm delete-affiliate',
              onClick: this.onClickDeleteAffiliate.bind(this),
              renderable: function() {
                return !isReadOnly;
              }
            }
          ]
        }),
        editable: false,
        sortable: false
      }
    ];
    this.options.emptyText = 'No Affiliates';
  },

  onClickDeleteAffiliate: function(e, model) {
    e.preventDefault();
    var self = this;
    var message = 'Are you sure you want to delete this affiliate?';
    UIUtil.showModal({
      title: 'Confirm Deleting Affiliate',
      view: new ConfirmationModalView({
        confirmText: 'Delete Affiliate',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var affiliateId = model.get('id');
            return SubmitAffiliate({ affiliateId: affiliateId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            self.collection.remove(model);
          }
        })
      })
    });
  }
});
